export const blocked = async (email: string): Promise<boolean> => {
    try {
        const blockedList = await fetch('https://assets.estadao.com.br/checkout/block-list.json')
            .then(res => res.json())
        return blockedList.find((e: string) => e === email)
    } catch (error) {
        return false;
    }
}